$(function() {
	//Confirmation Popup
	$("body").on("click", 'a[class^="ewk-"], .extwarn', function(e) {
		e.preventDefault();
		var containerId = "defaultsiteoverlay";
		var keyValue = "";
		var classes = $(this)
			.attr("class")
			.split(" ");
		for (var i = 0; i < classes.length; i++) {
			var matches = /^ewk\-(.+)/.exec(classes[i]);
			if (matches != null) {
				keyValue = matches[1];
			}
		}

		$.ajax({
			url: "/CFACOM/PageContent/ConfirmationOverlay",
			type: "GET",
			data: {
				OverlayKey: keyValue,
				UrlRedirectValue: $(this).prop("href")
			}
		}).done(function(partialViewResult) {
			$("#" + containerId).html(partialViewResult);

			$.magnificPopup.open({
				items: {
					src: "#" + containerId,
					type: "inline"
				}
			});
		});
	});
});
